export class SearchAbortedError extends Error {
  constructor() {
    super('Search request was superseded by a newer request')
    this.name = 'AbortError'
  }
}

/**
 * simpleStore.ajax() swallows fetch AbortErrors internally and resolves `null`
 * so a stale response can't be told apart from a genuine empty result. Call
 * this right after awaiting it so callers can detect and propagate the abort.
 */
export function throwIfAborted(signal?: AbortSignal): void {
  if (signal?.aborted) {
    throw new SearchAbortedError()
  }
}
